(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomTerrainTypeAttributeDialogController', CustomTerrainTypeAttributeDialogController);

    CustomTerrainTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomTerrainTypeAttribute'];

    function CustomTerrainTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomTerrainTypeAttribute) {
        var vm = this;

        vm.customTerrainTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customterraintypeattributevalues = CustomTerrainTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues != null && vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues.length != 0) {
			vm.items = vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customTerrainTypeAttribute.id !== null) {
            	
            	 vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomTerrainTypeAttribute.update(vm.customTerrainTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customTerrainTypeAttribute.customTerrainTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomTerrainTypeAttribute.save(vm.customTerrainTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customTerrainTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-terrain-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
